import React from "react";
import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";

import { Grandtotal } from "./Grandtotal";
import CollapseRow from "./CollapseRow";

const LineItems = ({
  lineNo,
  formData,
  openDialog,
  post,
  csvUplaodEnabled,
  searchParams,
}) => {
  return (
    <Grid item container xs={12}>
      <Grid item>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 450 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                {csvUplaodEnabled && (
                  <TableCell
                    align="center"
                    style={{ fontSize: 12, padding: 6 }}
                  >
                    Customer PO Number
                  </TableCell>
                )}
                <TableCell style={{ textAlign: "left" }} align="center">
                  Line No
                </TableCell>
                <TableCell style={{ fontSize: 12, padding: 6 }}>
                  Product Description
                </TableCell>
                <TableCell align="center" style={{ fontSize: 12, padding: 6 }}>
                  Quantity
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <CollapseRow
                lineNo={lineNo}
                formData={formData}
                openDialog={openDialog}
                post={post}
                searchParams={searchParams}
                csvUplaodEnabled={csvUplaodEnabled}
              />
              <Grandtotal
                data-testid="grandtotal-component"
                gfgcolor={lineNo}
                csvUplaodEnabled={csvUplaodEnabled}
              />
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default LineItems;
